import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { applyPreCheckItems } from '@/mocks/applyData';

export default function PreCheckSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('apply.precheck.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('apply.precheck.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('apply.precheck.titleEn')}
          </p>
          <div className="gold-line mx-auto mb-6"></div>
          <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {t('apply.precheck.lead')}
            <Link to="/application" className="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors">
              {t('apply.precheck.applicationLink')}
            </Link>
            {t('apply.precheck.leadSuffix')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {applyPreCheckItems.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 bg-background-100/60 border border-background-200/60 p-5"
            >
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-accent-500 text-lg`}></i>
              </div>
              <div>
                <p className="text-[15px] text-foreground-800 tracking-[0.04em] font-medium mb-1">
                  {t(`apply.preCheck.item.${idx}.label`)}
                </p>
                <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                  {t(`apply.preCheck.item.${idx}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
